import styled from 'styled-components';
export const AgreementTableWrapper = styled.div`
  & .no-data {
    text-align: center;
  }
`;
